import { render, staticRenderFns } from "./NewsCollection.vue?vue&type=template&id=67223b10&scoped=true"
import script from "./NewsCollection.vue?vue&type=script&lang=js"
export * from "./NewsCollection.vue?vue&type=script&lang=js"
import style0 from "./NewsCollection.vue?vue&type=style&index=0&id=67223b10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67223b10",
  null
  
)

export default component.exports